module.exports = __webpack_public_path__ + "img/Sanbabara.b97661df.jpg";